import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { StyledRadioButtons } from '../../../../Components/Generics.styled';
import styled from 'styled-components';
import { StyledButton } from '../../../../Components/Generics.styled';

const DoYouShipContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const DoYouShip = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { doYouShip } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (doYouShip !== '') {
            setValue(doYouShip);
        }
    }, [doYouShip]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, doYouShip: value }));
        handleNavButtonNext();
    };

    const options = [
        {
            value: 'yes',
            label: 'Yes',
        },
        {
            value: 'no',
            label: 'No',
        },
    ];

    return (
        <DoYouShipContainer>
            <StyledRadioButtons
                label={'Do you ship or deliver products to your customers?'}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                options={options}
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </DoYouShipContainer>
    );
};

DoYouShip.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

DoYouShip.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default DoYouShip;
